<template>
  <li class="wf-flex wf-justify-between wf-py-1">
    <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Full height</span>
    <div>
      <ToggleButton sync v-model="fullheight"/>
    </div>
  </li>
</template>

<script>
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      fullheight: {
        get() {
          return !! this.elementClasses(this.classes)[this.device].find(constant => constant.value == 'HEIGHT_SCREEN')
        },
        set(value) {
          if (value) {
            return this.addToArray(this.module, [{property: 'Height', value: 'HEIGHT_SCREEN', touched: false}], this.classes, this.device, {}, true, this.parentModule)
          }
          return this.addToArray(this.module, [{property: 'Height', value: 'HEIGHT_FULL', touched: false}], this.classes, this.device, {}, true, this.parentModule)
        }
      }
    }
  })
</script>